import axios from "axios";

import {
  ISEBankIDAuthenticateResponse,
  ISEBankIDCollectParams,
  ISEBankIDCollectResponse,
} from "./types";

const BASE_URL = "/api/v1/se/bank-id";

const AUTHENTICATE_URL = `${BASE_URL}/authenticate`;
const COLLECT_URL = `${BASE_URL}/collect`;
const CANCEL_URL = `${BASE_URL}/cancel`;

// Create axios instance without interceptors to avoid circular dependencies
const bankIDApiClient = axios.create({
  baseURL: import.meta.env.API_ROOT_URL,
});

/**
 * Initiate BankID authentication
 * @param ssn - Personal number (only used for testing in non-production)
 */
export const authenticateViaBankID = async (ssn?: string) => {
  return bankIDApiClient.post<ISEBankIDAuthenticateResponse>(AUTHENTICATE_URL, {
    ssn: ssn ?? undefined,
  });
};

/**
 * Collect authentication status
 * This endpoint is polled until the user completes or cancels the authentication
 */
export const collectViaBankID = async (params: ISEBankIDCollectParams) => {
  return bankIDApiClient.post<ISEBankIDCollectResponse>(COLLECT_URL, params);
};

/**
 * Cancel ongoing BankID authentication
 */
export const cancelViaBankID = async (orderRef: string) => {
  return bankIDApiClient.post(CANCEL_URL, { orderRef });
};
